export default __webpack_public_path__ + "static/media/Cover.840317ce.svg";